<div class="shell" [class.collapsed]="collapsed()">
  <aside class="content-panel" [class.content-panel--resizing]="panelResizing()" [style.width.px]="panelWidth()">
    <ng-content select="[panelHeader]" />
    <ng-content select="[panelTabs]" />
    <ng-content select="[panelSearch]" />
    <div class="content-panel__list">
      <ng-content select="[panelContent]" />
    </div>
    @if (!collapsed() && resizablePanel()) {
      <div class="content-panel__resize-handle" role="separator" aria-orientation="vertical" aria-label="Resize navigation panel" tabindex="-1" (pointerdown)="onPanelResizePointerDown($event)"></div>
    }
  </aside>
  <main class="content-main full-height-content">
    <ng-content select="[mainHeader]" />
    <div class="content-main__body">
      <ng-content select="[mainContent]" />
    </div>
  </main>
</div>
